<template>
  <div>
     <div v-if="limsds_userDetails.userEmail != null && limsds_userDetails.userEmail != ''">
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-row dense>
        <v-col sm="11" class="Instructions"
          >Enter criteria to search for Samples (fields left blank will not
          affect search)Loading...
        </v-col>
        <v-col align="Right" sm="1">
          <v-menu open-on-hover top offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="orange" small v-bind="attrs" v-on="on"
                >mdi-help</v-icon
              >
            </template>
            <v-list>
              <v-list-item
                ><a
                  :href="NewsLetter"
                  title="Newsletter Index"
                  target="limsds_help"
                  >Newsletter Index</a
                ></v-list-item
              >
            </v-list>
          </v-menu>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col sm="3">
          <v-select
            solo
            hide-details
            dense
            label="Select Site"
            v-model="list.site1"
            @input="FillUnitDropDown"
            :items="defaultValues.SiteList"
            item-text="site"
            item-value="site"
          ></v-select>
        </v-col>
        <v-col sm="3" v-show="Show">
          <v-select
            solo
            hide-details
            dense
            label="Select Label Template"
            v-model="defaultValues.SelectedLabelTemp"
            :items="defaultValues.LabelTemplateList"
            item-text="Name"
            item-value="Identity"
          ></v-select>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col sm="3">
          <v-select
            label="Select Unit"
            v-model="list.SelectedUnit"
            @input="FillAreaDropDown"
            :items="defaultValues.UnitList"
            solo
            hide-details
            dense
            item-text="UnitName"
            item-value="UnitValue"
          ></v-select>
        </v-col>
        <v-col sm="3" v-show="Show">
          <v-select
            label="Printer"
            v-model="defaultValues.SelectedPrinter"
            :items="defaultValues.PrinterList"
            solo
            hide-details
            dense
            item-text="Name"
            item-value="Identity"
          ></v-select>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col sm="3">
          <v-select
            solo
            hide-details
            dense
            label="Select Area"
            v-model="list.SelectedArea"
            :items="defaultValues.AreaList"
            item-text="value"
            item-value="key"
          ></v-select>
        </v-col>
        <v-col sm="3" v-show="Show">
          <v-text-field
            v-model="defaultValues.Copies"
            dense
            solo
            hide-details
            type="Number"
            label="Copies"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col sm="3">
          <v-select
            solo
            hide-details
            dense
            label="Sample Point"
            v-model="defaultValues.SelectedSamplePoint"
            :items="defaultValues.SamplePointList"
            item-text="Name"
            item-value="Identity"
            @input="FillProductDropDown()"
          ></v-select>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col sm="3">
          <v-select
            solo
            hide-details
            dense
            label="Select Product"
            v-model="defaultValues.SelectedProduct"
            :items="defaultValues.ProductList"
            item-text="Name"
            item-value="Identity"
            @input="FillSamplePointDropDown()"
          ></v-select>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col sm="3">
          <v-select
            label="Sample Status"
            v-model="defaultValues.SelectedSampleStatus"
            dense
            solo
            hide-details
            :items="defaultValues.itemsSampleStatus"
            item-text="name"
            item-value="id"
          ></v-select>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col >
          <start-end-date-control
            :startDate.sync="dateValues.startDate"
            :endDate.sync="dateValues.endDate"
            :numIncSD.sync="dateValues.numIncSD"
            :numIncED.sync="dateValues.numIncED"
          ></start-end-date-control>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col sm="2">
          <v-btn
            :disabled="!valid"
            rounded
            dense
            solo
            hide-details
            color="primary"
            dark
            @click="GetSample()"
            >Get Samples
          </v-btn>
        </v-col>
        <v-col sm="2" v-show="Show">
          <v-btn
            rounded
            dense
            solo
            hide-details
            color="primary"
            dark
            @click="PrintLabel()"
            >Print Labels
          </v-btn>
        </v-col>
      </v-row>

      <v-row dense v-show="Show">
        <v-col>
          <v-data-table
            dense
            v-model="SelectedSampleListResult"
            :headers="Resultheaders"
            :items="SampleListResult"
            :footer-props="{
              'items-per-page-options': [5, 10, 15, 20],
            }"
            :items-per-page="list.Rowsinresulttable"
            item-key="IdNumeric"
            :loading="isLoading"
            loading-text="Loading... Please wait"
            show-select
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Available Sample</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
            </template>
          </v-data-table>
        </v-col>
      </v-row>

      <v-row dense v-show="ShowPrint">
        <v-col>
          <v-data-table
            dense
            :headers="PrintResultheaders"
            :items="defaultValues.PrintLabelResult"
            :footer-props="{
              'items-per-page-options': [5, 10, 15, 20],
            }"
            :items-per-page="list.Rowsinresulttable"
            item-key="Id"
            :loading="isLoading"
            loading-text="Loading... Please wait"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Print Sample</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
            </template>
            <template v-slot:item="{ item }">
              <tr>
                <td>
                  <div
                    :style="{ color: ' #00FF00' }"
                    v-if="item.IsError == false"
                  >
                    <b> Successful</b>
                  </div>
                  <div
                    :style="{ color: ' #f67e7e' }"
                    v-if="item.IsError == true"
                  >
                    <b> Failed </b>
                  </div>
                </td>
                <td>{{ item.Message }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-form>
    </div>
    <div v-if="limsds_userDetails.userEmail == null">
      <h3>INVALID USER !!!</h3>
      <h4>Current user is not exist in system database !!!</h4>
    </div>
  </div>
</template>
<script>
import uiView from "@/_mixins/ui-view-mixin";
import axios from "axios";
import startEndDateControl from "../components/startEndDateControl";
import appMixin from "../mixins/app-mixin";
export default {
  name: "SampleLabelPrint",
  mixins: [uiView, appMixin],
  components: { startEndDateControl },

  created() {
    let that = this;
    this.NewsLetter = this.settings.NewsLetter;
    if (this.limsds_userDetails.userEmail != null){
        this.fillSite();
        this.list = this.limsds_userPreference;
      this.PrefSite = this.list.site1;
      this.FillUnitDropDown(this.list.site1);
      this.FillAreaDropDown(this.list.SelectedUnit);
      this.FillSamplePointDropDown(
        this.list.site1,
        this.list.SelectedUnit,
        this.list.SelectedArea,
        this.defaultValues.SelectedProduct
      );
      this.FillProductDropDown(
        this.list.site1,
        this.list.SelectedUnit,
        this.list.SelectedArea,
        this.defaultValues.SelectedSamplePoint
      );
      this.FillLabelPrinterDropDown();
    }
  },
  mounted() {},

  data() {
    return {
      valid: true,
      Show: false,
      ShowPrint: false,
      isLoading: false,
      list: {},
      SampleListResult: [],
      SelectedSampleListResult: [],
      dateValues: {
        numIncSD: "-1",
        numIncED: "0",
        startDate: null,
        endDate: null,
      },
      defaultValues: {
        Copies: 1,
        SiteList: undefined,
        LabelTemplateList: [],
        PrinterList: [],
        PrintLabelResult: [],
        SelectedPrinter: "",
        UnitList: undefined,
        AreaList: undefined,
        SamplePointList: [],
        ProductList: undefined,
        SelectedLabelTemp: "",
        onlySamplesPreviousYear: "1",
        lims_internal: "0",
        SelectedSite: null,
        SelectedUnit: null,
        SelectedArea: null,
        SelectedSamplePoint: "all",
        SelectedProduct: "all",
        SelectedSampleStatus: "All",
        itemsSampleStatus: [
          { name: "All Status", id: "All" },
          { name: "Authorised", id: "A" },
          { name: "Available", id: "V" },
          { name: "Awaiting Preparation", id: "W" },
          { name: "Cancelled", id: "X" },
          { name: "Completed", id: "C" },
          { name: "Disposed", id: "D" },
          { name: "Expired", id: "E" },
          { name: "Inspection", id: "I" },
          { name: "On Hold", id: "H" },
          { name: "Rejected", id: "r" },
          { name: "Retained", id: "B" },
          { name: "Suspended", id: "S" },
          { name: "Taken", id: "T" },
          { name: "Unavailable", id: "U" },
        ],
      },

      PrintResultheaders: [
        { text: "Status" },
        { text: "Message", value: "Message" },
      ],
      Resultheaders: [
        {
          text: "Sample Number",
          value: "IdNumeric",
          align: "start",
          sortable: false,
        },
        { text: "Sample ID", value: "IdText" },
        { text: "Sample Date", value: "SampledDate" },
        { text: "Sample Point", value: "SamplePoint" },
        { text: "Product", value: "Product" },
        { text: "Sample Name", value: "SampleName" },
        { text: "Description", value: "Description" },
        { text: "Comments", value: "Comments" },
        { text: "Status", value: "Status" },
        { text: "LabelPrinter", value: "LabelPrinter" },
        { text: "Label Template", value: "LabelTemplate" },
      ],
    };
  },
  methods: {
    fillSite(){
        let that = this;
    const SiteLink =
      this.settings.WASite + "UserID=" + this.limsds_userDetails.userEmail;
    axios.get(SiteLink).then((response) => {
      that.defaultValues.SiteList = response.data.enumSiteLists;
    });
    },
    PrintLabel(sampleIds = "") {
      this.ShowPrint = true;
      sampleIds += this.SelectedSampleListResult.map((e) => {
        return `${e.IdNumeric},`;
      }).join("");
      const Print =
        this.settings.WAPrint +
        "sampleIds=" +
        sampleIds +
        "&site=" +
        this.list.site1 +
        "&unit=" +
        this.list.SelectedUnit +
        "&labelTemplate=" +
        this.defaultValues.SelectedLabelTemp +
        "&printer=" +
        this.defaultValues.SelectedPrinter +
        "&numberOfPrintCopies=" +
        this.defaultValues.Copies;
      axios.get(Print).then((response) => {
        console.log(response.data);
        this.defaultValues.PrintLabelResult = JSON.parse(response.data);
      });
    },
    GetSample() {
      this.isLoading = true;
      this.Show = true;
      var that = this;
      const Samples =
        this.settings.WASamples +
        "site=" +
        this.list.site1 +
        "&unit=" +
        this.list.SelectedUnit +
        "&area=" +
        this.list.SelectedArea +
        "&samplePoint=" +
        this.defaultValues.SelectedSamplePoint +
        "&status=" +
        this.defaultValues.SelectedSampleStatus +
        "&startDate=" +
        this.dateValues.startDate +
        "&endDate=" +
        this.dateValues.endDate +
        "&preferredDateFormat=MM/DD/YYYY&timezoneoffset=12";
      axios.get(Samples).then((response) => {
        this.SampleListResult = JSON.parse(response.data.value);
      });
      this.isLoading = false;
    },
    FillUnitDropDown(value) {
      const UnitLink =
        this.settings.WAUnit +
        "UserID=" +
        this.limsds_userDetails.userEmail +
        "&site=" +
        this.list.site1 +
        "&lims_internal=" +
        this.defaultValues.lims_internal +
        "&onlySamplesPreviousYear=" +
        this.defaultValues.onlySamplesPreviousYear;
      axios.get(UnitLink).then((response) => {
        this.defaultValues.UnitList = response.data.unitLists;
      });
    },
    FillAreaDropDown(value) {
      const AreaLink =
        this.settings.SMWAArea +
        "site=" +
        this.list.site1 +
        "&unit=" +
        this.list.SelectedUnit +
        "&preferredArea=" +
        "";
      axios.get(AreaLink).then((response) => {
        this.defaultValues.AreaList = response.data;
      });
    },
    FillSamplePointDropDown() {
      var that = this;
      if (
        this.list.SelectedUnit == null ||
        this.list.SelectedUnit == undefined ||
        this.list.SelectedUnit == ""
      ) {
        this.list.SelectedUnit = "all";
      }
      if (
        this.list.SelectedArea == null ||
        this.list.SelectedArea == undefined ||
        this.list.SelectedArea == ""
      ) {
        this.list.SelectedArea = "all";
      }
      const SamplePoints =
        this.settings.WASamplePoints +
        "site=" +
        this.list.site1 +
        "&unit=" +
        this.list.SelectedUnit +
        "&areaID=" +
        this.list.SelectedArea +
        "&product=" +
        this.defaultValues.SelectedProduct;
      axios
        .get(SamplePoints)
        .then((response) => {
          var SamplepointTemp = [{ Name: "All Sample Point", Identity: "all" }];
          SamplepointTemp.push(...JSON.parse(response.data));
          that.$set(that.defaultValues, "SamplePointList", SamplepointTemp);
        });
    },
    FillProductDropDown() {
      var that = this;
      if (
        this.list.SelectedUnit == null ||
        this.list.SelectedUnit == undefined ||
        this.list.SelectedUnit == ""
      ) {
        this.list.SelectedUnit = "all";
      }
      if (
        this.list.SelectedArea == null ||
        this.list.SelectedArea == undefined ||
        this.list.SelectedArea == ""
      ) {
        this.list.SelectedArea = "all";
      }
      const Product =
        this.settings.WAProductList +
        "site=" +
        this.list.site1 +
        "&unit=" +
        this.list.SelectedUnit +
        "&areaID=" +
        this.list.SelectedArea +
        "&samplePointID=" +
        this.defaultValues.SelectedSamplePoint;

      axios.get(Product).then((response) => {
        var productTemp = [{ Name: "All Product", Identity: "all" }];
        productTemp.push(...JSON.parse(response.data));
        that.$set(that.defaultValues, "ProductList", productTemp);
      });
    },
    FillLabelPrinterDropDown() {
      const LabelTemplateLink =
        this.settings.WALabelTemplate +
        "site=" +
        this.list.site1 +
        "&unit=" +
        this.list.SelectedUnit;
      axios.get(LabelTemplateLink).then((response) => {
        this.defaultValues.LabelTemplateList.push({
          Name: "Default Label Template",
          Identity: "",
        });
        this.defaultValues.LabelTemplateList.push(
          ...JSON.parse(response.data.value)
        );
      });

      const PrinterLink =
        this.settings.WAPrinter +
        "site=" +
        this.list.site1 +
        "&unit=" +
        this.list.SelectedUnit;
      axios.get(PrinterLink).then((response) => {
        this.defaultValues.PrinterList.push({
          Name: "Default Printer",
          Identity: "",
        });
        this.defaultValues.PrinterList.push(...JSON.parse(response.data.value));
      });
    },
  },
};
</script>
<style lang="scss">
.v-text-field.v-text-field--solo.v-input--dense > .v-input__control, .v-text-field--filled.v-input--dense.v-text-field--single-line > .v-input__control > .v-input__slot {
    min-height: 24px;
}
.v-text-field--filled.v-input--dense.v-text-field--single-line .v-label, .v-text-field--full-width.v-input--dense.v-text-field--single-line .v-label {
    top: 3px;
}
.v-text-field__slot {
    padding: 0px !important;
}
.v-btn:not(.v-btn--round).v-size--default {
  height: 26px;
  min-width: 64px;
  padding: 0 10px;
}
</style>